// App MOP ADMIN — administration des COMPTES et des FORFAITS.
// Réservée à l'ADMIN et au COMMERCE : tout autre compte connecté voit un écran
// d'accès refusé (et les règles Firestore refusent de toute façon la lecture de
// `users` / l'écriture de `config/fonctionnalites` sans le claim adéquat).
// Aucune donnée « métier » ici : ni calendrier, ni inventaire.
import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { StatusBar } from 'expo-status-bar';
import { GestureHandlerRootView } from 'react-native-gesture-handler';
import {
  CoreProviders, CoquilleApp, EcranProfil, EmptyState, PageHeader,
  useAuth, useT, useUI, FonctionsProvider, FONCTIONS_CORE,
} from '@mop/core';
import EcranComptes from './src/EcranComptes';
import EcranForfaits from './src/EcranForfaits';
import EcranAcces from './src/EcranAcces';

const APP = { id: 'mop-admin', nom: 'MoP Admin', version: '0.5.1.20', scheme: 'mopadmin' };

// Garde d'acces. `avecIVV` ouvre l'ecran aux VALIDEURS : ils doivent pouvoir
// regler les quotas par forfait pour tester l'app dans chaque configuration.
// Les regles Firestore limitent leur ecriture aux seuls quotas (`plans`) —
// ils ne peuvent ni couper une fonction pour tous, ni changer les paliers.
const Reserve = ({ children, avecIVV = false }) => {
  const { estAdmin, estCommerce, estIVV } = useAuth();
  const UI = useUI();
  const t = useT();
  if (estAdmin || estCommerce || (avecIVV && estIVV)) return children;
  return (
    <View style={{ flex: 1, backgroundColor: UI.bg }}>
      <PageHeader titre={APP.nom} iconeTitre="🛡️" />
      <EmptyState icon="🚫" texte={t('admin.accesRefuse')} aide={t('admin.accesRefuseAide')} />
    </View>
  );
};

const Comptes  = () => <Reserve><EcranComptes /></Reserve>;
const Forfaits = () => <Reserve avecIVV><EcranForfaits /></Reserve>;
const Acces    = () => <Reserve><EcranAcces /></Reserve>;
const Profil   = () => <EcranProfil sections={[]} />;

const Racine = () => {
  const t = useT();
  const onglets = [
    { cle: 'Comptes',  label: t('admin.comptes'),  icone: '👥', composant: Comptes },
    { cle: 'Forfaits', label: t('admin.forfaits'), icone: '🧩', composant: Forfaits },
    { cle: 'Acces',    label: t('admin.acces'),    icone: '🔑', composant: Acces },
    { cle: 'Profil',   label: t('nav.profil'),     icone: '👤', composant: Profil },
  ];
  // Pas de pub dans un outil interne.
  return <CoquilleApp onglets={onglets} />;
};

export default function App() {
  return (
    <GestureHandlerRootView style={{ flex: 1 }}>
      <CoreProviders app={APP} theme="auto">
        <FonctionsProvider catalogue={FONCTIONS_CORE}>
          <StatusBar style="auto" />
          <Racine />
        </FonctionsProvider>
      </CoreProviders>
    </GestureHandlerRootView>
  );
}

// eslint-disable-next-line no-unused-vars
const _styles = StyleSheet.create({});
